module.exports = __webpack_public_path__ + "media/widget/Udi-41c6d002.png";